import React from "react"

export const DashboardScreen: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="mb-4 text-2xl font-bold text-gray-900">Dashboard</h1>
      <p className="text-gray-600">TODO</p>
    </div>
  )
}
